import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ENDPOINT_PERMISSIONS } from '../auth/permissions.config';

export const permissionInterceptorFn: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const url = req.url;
  const method = req.method;

  const requiredRoles = getRequiredRoles(url, method);

  if (requiredRoles && requiredRoles.length > 0) {
    if (!authService.hasAnyRole(requiredRoles)) {
      console.warn(`Permission denied: ${method} ${url} - Required roles: ${requiredRoles.join(', ')}`);
      return throwError(() => new Error(`Insufficient permissions for ${method} ${url}`));
    }
  }

  return next(req);
};

function getRequiredRoles(url: string, method: string): string[] | null {
  for (const [endpoint, permission] of Object.entries(ENDPOINT_PERMISSIONS)) {
    if (url.includes(endpoint)) {
      if (permission.methods && !permission.methods.includes(method)) {
        continue;
      }
      return permission.roles;
    }
  }

  return null;
}
